<template>
    <queue-receiver ns="notify" :transition="transition" class="notifications">
        <template #item="{data, close}">
            <notification v-bind="data" @close="close"/>
        </template>
    </queue-receiver>
</template>

<script>
    export default {
        props: {
            transition: {type: String, default: 'from-right'},
        },

        components: {
            'notification': require('./Notification').default,
        },
    };
</script>
